import axios from "axios";

// Single axios instance for the app — automatically attaches the auth token from localStorage.
const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("crow_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default API;
